  export enum FreeBookStatusEnum {
  ABSENT = 'ABSENT',
  ATTENDED = 'ATTENDED',
  BOOKED = 'BOOKED',
  MANAGED = 'MANAGED',
}
